import React from 'react';

import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType
} from 'react-router-dom';

import App from './app';
import { env } from './lib/env';

import './app.css';

Sentry.init({
	dsn: env.VITE_SENTRY_DSN,
	environment: import.meta.env.MODE || 'development',

	release: `main-app@@${import.meta.env.VITE_APP_VERSION || 'unknown'}`,
	initialScope: {
		tags: {
			app: 'main-app'
		}
	},

	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.reactRouterV6BrowserTracingIntegration({
			useEffect: React.useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes
		}),
		Sentry.replayIntegration({
			maskAllText: true,
			blockAllMedia: true
		}),
		Sentry.extraErrorDataIntegration({
			depth: 5
		}),
		Sentry.httpClientIntegration({
			failedRequestStatusCodes: [[500, 599]]
		})
	],

	tracesSampleRate:
		(import.meta.env.MODE || 'development') === 'production' ? 0.2 : 1.0,

	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,

	ignoreErrors: [
		'Extension context invalidated',
		'ResizeObserver loop limit exceeded'
	],
	denyUrls: [/extensions\//i, /^chrome:\/\//i]
});

createRoot(document.getElementById('root') as HTMLElement).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
